/*
 * File: ZoominfoEmplyeeCard.tsx
 * Project: a-a
 * File Created: Tuesday, 4th November 2025 10:03:21 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 18th November 2025 12:42:12 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Checkbox, Chip, Divider, Skeleton, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import zeplinColor from '../../../../theme/Color';
import { ReactComponent as CopyLinkIcon } from '../../../../assets/copy-link.svg';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';
import CustomPopOver from '../../../shared/CustomPopOver/CustomPopOver';
import { ZoomInfoService } from '../../../../service/zoominfo.service';
import { Utilities } from '../../../../utilities/utilities';
import { useLocation } from 'react-router-dom';

const ZoominfoEmplyeeCard = ({
  setSelected,
  selected,
  val,
  loading,
  setError,
}: {
  setSelected: React.Dispatch<React.SetStateAction<string[]>>;
  selected: string[];
  val: any;
  loading: boolean;
  setError: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  console.log(val);
  const location = useLocation();
  const theme = useTheme();
  const [copy, setCopy] = useState('');
  const [emailLink, setEmailLink] = useState('');
  const [phone, setPhone] = useState('');
  const [anchorEl, setAnchorEl] = React.useState<HTMLImageElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleCopyLink = (val: any, type: string) => {
    // console.log() .
    navigator.clipboard.writeText(val);
    setCopy(`${type} copied`);
  };
  const handleClose = () => {
    setCopy('');
  };
  const details = val;
  const exportContact = async (id: string) => {
    try {
      const payload = {
        contactIds: [id],
      };

      const res = await ZoomInfoService.exportContacts(
        location?.pathname.split('/')[2] || '',
        payload,
      );
      Utilities.downloadCSV(res, 'Contact details');
    } catch (err) {
      setError(true);
    }
  };
  return (
    <Box
      sx={{
        flex: 1,
        padding: '0px 12px',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', flex: 1, padding: '16px 0px' }}>
        <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <Checkbox
            checked={selected.indexOf(details?.id?.toString()) > -1 || false} // Controlled state
            onChange={(checked) => {
              const filtered = selected?.filter((val: any) => val !== details?.id?.toString());
              console.log(
                selected,
                selected?.filter((val: any) => val !== details?.id?.toString()),
              );
              setSelected((prev: any) =>
                selected.indexOf(details?.id?.toString()) > -1
                  ? [...filtered?.map((val: any) => val?.toString())]
                  : [...prev, details?.id?.toString()],
              ); // Update local state
            }}
            sx={{
              padding: '0px',
              color: zeplinColor.BasicBlack,
              '&.Mui-checked': { color: zeplinColor.BasicBlack },
            }}
          />
          <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            {loading ? (
              <Skeleton
                variant='rounded'
                width={48}
                height={48}
                sx={{ backgroundColor: zeplinColor.Neutral4 }}
              />
            ) : (
              <img
                // className={style['avatar']}

                src={details?.photo || ''}
                alt='logo'
                loading='lazy'
                style={{
                  objectFit: 'fill',
                  borderRadius: '14px',
                  width: '48px',
                  height: '48px',
                  border: `1px solid ${zeplinColor.BasicBlack}`,
                }}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = '/assets/profile.svg';
                }}
              />
            )}
            {/* ) : (
      <Typography variant='display4' sx={{ color: zeplinColor.Neutral1 }}>
        {details?.accountName
          ?.split(' ')
          .map((val: any, index: number) =>
            index === 0 || index === details?.accountName?.split(' ').length - 1 ? val[0] : '',
          )}
      </Typography> */}
            <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    width: '5rem',
                    backgroundColor: zeplinColor.Neutral4,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Box sx={{ display: 'flex', gap: '4px' }}>
                  {' '}
                  <Typography variant='responsiveBody2'>
                    {details?.firstName} {details?.lastName}
                  </Typography>
                  <img
                    // className={style['avatar']}
                    src={'/assets/linkedin-link.svg'}
                    alt='logo'
                    loading='lazy'
                    style={{ objectFit: 'fill', width: '18px', height: '18px' }}
                  />
                </Box>
              )}

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    width: '5rem',
                    backgroundColor: zeplinColor.Neutral4,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
                  {details?.jobTitle}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          {/* <Chip
            label={
              loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    width: '5rem',
                    backgroundColor: zeplinColor.Neutral4,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography
                  variant='responsiveLabel1'
                  sx={{ display: 'flex', alignItems: 'center' }}
                  color={zeplinColor.BasicBlack}
                >
                  No engagement
                </Typography>
              )
            }
            sx={{
              backgroundColor: zeplinColor.Neutral4,
              color: zeplinColor.Neutral1,
              '&.MuiChip-root': {
                height: '24px',
                padding: '5px 12px',
                borderRadius: '50px',
              },
              '& .MuiChip-label': {
                padding: 0,
              },
            }}
          /> */}
          {/* <Box
            sx={{
              height: '22px',
              width: '1px',
              backgroundColor: zeplinColor.Neutral5,
              display: 'inline-block',
              marginX: '4px', // Add some margin on both sides
            }}
          /> */}
          <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {loading ? (
              <Skeleton
                variant='rounded'
                width={20}
                height={20}
                sx={{ backgroundColor: zeplinColor.Neutral4 }}
              />
            ) : details?.email ? (
              <Box
                sx={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'center',
                  borderRadius: '50px',
                  ':hover': { backgroundColor: zeplinColor.Neutral3 },

                  padding: '10px',
                }}
              >
                <img
                  // className={style['avatar']}
                  onClick={(e) =>
                    // handleCopyLink(details?.email, 'Email')
                    {
                      handleClick(e);
                      setPhone('');
                      setEmailLink(details?.email);
                    }
                  }
                  src={'/assets/zoominfo-mail.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{ objectFit: 'fill', width: '20px', height: '20px' }}
                />
              </Box>
            ) : (
              ''
            )}
            {loading ? (
              <Skeleton
                variant='rounded'
                width={20}
                height={20}
                sx={{ backgroundColor: zeplinColor.Neutral4 }}
              />
            ) : details?.mobilePhone ? (
              <Box
                sx={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'center',
                  borderRadius: '50px',
                  ':hover': { backgroundColor: zeplinColor.Neutral3 },

                  padding: '10px',
                }}
              >
                <img
                  // className={style['avatar']}
                  onClick={(e: any) => {
                    handleClick(e);
                    setEmailLink('');
                    // console.log(details?.phone);
                    setPhone(details?.mobilePhone);
                  }}
                  src={'/assets/zoominfo-call.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{ objectFit: 'fill', width: '20px', height: '20px' }}
                />
              </Box>
            ) : (
              ''
            )}
            {/* <img
              // className={style['avatar']}
              onClick={() => handleCopyLink(details?.phone, 'Mobile number')}
              src={'/assets/zoominfo-mobile.svg'}
              alt='logo'
              loading='lazy'
              style={{ objectFit: 'fill', width: '20px', height: '20px' }}
            /> */}
          </Box>
          <Box
            sx={{
              height: '22px',
              width: '1px',
              backgroundColor: zeplinColor.Neutral5,
              display: 'inline-block',
              marginX: '4px', // Add some margin on both sides
            }}
          />
          {/* {loading ? (
            <Skeleton
              variant='rounded'
              width={20}
              height={20}
              sx={{ backgroundColor: zeplinColor.Neutral4 }}
            />
          ) : (
            <img
              // className={style['avatar']}
              src={'/assets/zoominfo-employee-add.svg'}
              alt='logo'
              loading='lazy'
              style={{ objectFit: 'fill', width: '20px', height: '20px' }}
            />
          )} */}
          {/* <Box
            sx={{
              height: '22px',
              width: '1px',
              backgroundColor: zeplinColor.Neutral5,
              display: 'inline-block',
              marginX: '4px', // Add some margin on both sides
            }}
          /> */}
          {loading ? (
            <Skeleton
              variant='rounded'
              width={20}
              height={20}
              sx={{ backgroundColor: zeplinColor.Neutral4 }}
            />
          ) : (
            <Box
              sx={{
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
                borderRadius: '50px',
                ':hover': { backgroundColor: zeplinColor.Neutral3 },

                padding: '10px',
              }}
            >
              <img
                // className={style['avatar']}
                src={'/assets/zoominfo-employee-share.svg'}
                alt='logo'
                loading='lazy'
                style={{ objectFit: 'fill', width: '20px', height: '20px' }}
                onClick={() => exportContact(details?.id?.toString())}
              />
            </Box>
          )}
        </Box>
      </Box>
      <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} />
      <CustomPopOver
        onClick={(e: any) => {
          e.stopPropagation();
        }}
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        id={id}
        sx={{ borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            padding: '16px',
          }}
        >
          <Box
            sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation();
              handleCopyLink(phone ? phone : emailLink, phone ? 'Phone' : 'Email');
              setAnchorEl(null);
            }}
          >
            {/* <img src={'/assets/copy-link.svg'} width={18} height={18} /> */}
            <CopyLinkIcon width={18} height={18} />
            <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
              Copy
            </Typography>
          </Box>
          {emailLink && (
            <a
              href={`mailto:${emailLink}`}
              onClick={(e) => {
                e.stopPropagation();
                setAnchorEl(null);
                // handleCopyLink(data?.link);
              }}
              target='_blank'
              rel='noopener noreferrer'
              style={{ textDecoration: 'none' }}
            >
              <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}>
                <img
                  // className={style['avatar']}

                  src={'/assets/zoominfo-mail.svg'}
                  alt='logo'
                  loading='lazy'
                  style={{ objectFit: 'fill', width: '18px', height: '18px' }}
                />
                <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                  Email
                </Typography>
              </Box>
            </a>
          )}
        </Box>
      </CustomPopOver>
      <CustomAlert
        open={copy ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alert={copy}
            alertIcon={<img src='/assets/checkmark-green.png' width={24} height={24} />}
            error={false}
          />
        }
        error={false}
      />
    </Box>
  );
};

export default ZoominfoEmplyeeCard;
